import React from 'react';
import TypographyWrapper from '../../components/TypographyWrapper/TypographyWrapper';
import { useShopConfigV2 } from '../../hooks/shopConfig';

const ListAnyBrandDescription = () => {
  const { treetShopName, listingFlowConfig } = useShopConfigV2();
  const { supportedBrandsLink } = listingFlowConfig;
  return (
    <>
      {supportedBrandsLink && (
        <TypographyWrapper variant="body1">
          {treetShopName} allows for items to be sold from these{' '}
          <a
            href={supportedBrandsLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}
          >
            supported brands
          </a>
          .
        </TypographyWrapper>
      )}
    </>
  );
};

export default ListAnyBrandDescription;
